import axios from 'axios';

import {
  axiosHeader,
  axiosHeaderV2,
  getV1RootUrl,
  getV2RootUrl
} from 'common/helpers/apiHelper';

export const editClubShipmentItems = (customerId, shipmentId, items) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/items`,
    { items },
    axiosHeaderV2()
  );

export const getSubscriptionClubShipmentVirtualCart = (
  customerId,
  clubSubscriptionShipmentId
) =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${clubSubscriptionShipmentId}/virtual-cart`,
    axiosHeaderV2()
  );

export const getClubSubscriptionShipmentVirtualCartLimited = (
  clubSubscriptionShipmentId
) =>
  axios.get(
    `${getV2RootUrl()}/club-subscription-shipment/${clubSubscriptionShipmentId}/virtual-cart/limited`,
    axiosHeaderV2()
  );

export const editClubVirtualShipmentItems = (customerId, shipmentId, items) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/virtual-cart`,
    { items },
    axiosHeaderV2()
  );

export const processClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/process`,
    null,
    axiosHeader()
  );

export const skipClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/skip`,
    {},
    axiosHeaderV2()
  );

export const unskipClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/unskip`,
    {},
    axiosHeaderV2()
  );
